import styled from "styled-components"
import { Rating } from "@mui/material"
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import StarBorderRoundedIcon from '@mui/icons-material/StarBorderRounded';
import moment from "moment";
import Review from "../../models/Review.model";
import { useEffect, useRef, useState } from "react";
import { maskName } from "../../utils/Utils";


type ReviewProps = {
  review: Review
  ellipsisHeight: number
  onClickMore?: boolean
  isMyReview?: boolean
  onEdit?: () => void
  onDelete?: () => void
}

export default function ReviewItem(props: ReviewProps) {

  const anchorRef = useRef<HTMLParagraphElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const [isEllipsis, setIsEllipsis] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setIsMenuOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  useEffect(() => {
    if(anchorRef.current === null) return;

    setIsEllipsis(anchorRef.current.offsetHeight >= props.ellipsisHeight);
    
  }, [props.review])

  return(
    <ReviewItemDiv className="review_item">
      <div className="top">
        <Rating
          value={props.review.rating}
          readOnly
          precision={0.5}
          icon={<StarRoundedIcon />}
          emptyIcon={<StarBorderRoundedIcon />}
        />
        {props.isMyReview && (
          <div className="btn-group" ref={menuRef}>
            <button
              className="menu-trigger"
              onClick={() => setIsMenuOpen(prev => !prev)}
            >···</button>
            {isMenuOpen && (
              <div className="dropdown">
                <button onClick={() => { setIsMenuOpen(false); props.onEdit?.() }}>수정</button>
                <button onClick={() => { setIsMenuOpen(false); props.onDelete?.() }}>삭제</button>
              </div>
            )}
          </div>
        )}
      </div>
      <p
        ref={anchorRef}
        className={`contents gray_9a ${isEllipsis? 'ellipsis' : ''}`}
      >{props.review.description}</p>
      {isEllipsis && <button className="bold"
        onClick={() => {
          props.onClickMore && setIsEllipsis(false)
        }}
      >더보기</button>}
      <strong>{maskName(props.review.name)} <span className="gray_9a">{moment(props.review.createdAt).format('YYYY-MM-DD')}</span></strong>
    </ReviewItemDiv>
  )
}


const ReviewItemDiv = styled.div`
  padding: 30px 0;
  .top{
    display: flex;
    align-items: center;
    .btn-group{
      margin: 0 0 0 auto;
      position: relative;
      .menu-trigger{
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--gray_9a);
        font-size: 18px;
        letter-spacing: 1px;
        padding: 0;
        &:hover{
          color: #222;
        }
      }
      .dropdown{
        position: absolute;
        right: 0;
        top: 36px;
        background: #fff;
        border: 1px solid #e0e0e0;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.12);
        z-index: 10;
        min-width: 80px;
        overflow: hidden;
        button{
          width: 100%;
          padding: 10px 16px;
          text-align: left;
          font-size: 14px;
          color: #444;
          border: none;
          background: transparent;
          &:hover{
            background: #f5f5f5;
            color: #222;
          }
        }
      }
    }
  }
  .contents{
    margin: 20px 0 0;
    font-size: 16px;
    line-height: 24px;

    &.ellipsis{
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }

  button{
    padding: 6px 0;
    border: none;
    background-color: transparent;
    font-size: 16px;
  }
  strong{
    margin: 24px 0 0;
    font-size: 18px;
    span{
      padding: 0 0 0 15px;
    }
  }
`